import {AngularFireDatabase, FirebaseListObservable} from 'angularfire2/database';
// import { AngularFireAuth } from 'angularfire2/auth';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {Profiles} from '../../model/Profiles';
// import * as firebase from 'firebase/app';
import {LoggerService} from '../logger-service';
// import {iProfile} from '../../model/iProfile';

@Injectable()
export class UserProfileProvider {
  // user: Observable<firebase.User>;
  profiles: FirebaseListObservable<any>;

  constructor(public db: AngularFireDatabase,
              // public afAuth: AngularFireAuth,
              private logger: LoggerService) {
    // this.user = afAuth.authState;
    this.profiles = db.list('userProfile');

    this.logger.log.debug('Hello UserProfileProvider Provider');
  }

  displayUserProfiles(): void {
    this.profiles.subscribe(profiles => profiles.forEach(profile => console.log(profile)));
  }

  //Get user profile
  getUserProfile(): Observable<Profiles> {


    return this.profiles.map(res => res.json() as Profiles)
      // .map(allProfileData => {
      // return new Profiles(allProfileData);
    // }
    .finally(() => {
      this.logger.log.debug(' all profiles returned as objects and now convert into iProfile object.');
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-profile/user-profile.ts